var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeOffReport',{attrs:{"timeOffReportUserId":_vm.currentUserId || _vm.timeOffReportUserId,"isPage":_vm.isPage,"timeOffReportUser":_vm.timeOffReportUser,"hideMonthsSection":_vm.hideMonthsSection,"breadcrumbs":_vm.breadcrumbs},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }